import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { ConfigService } from '@app/core/services/config.service';
import { GlobalConstants } from '@app/portal/global-constants';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-footer-application',
  templateUrl: './footer-application.component.html'
})
export class FooterApplicationComponent {
  appTitle = GlobalConstants.appInfo.appTitle;
  appYear: number = new Date().getFullYear();
  appVersion?: string;


  constructor(private configService: ConfigService, private httpClient: HttpClient) {
    let publicPath = this.configService.appConfig.apic.baseUrl + this.configService.appConfig.apic.apiPath + this.configService.appConfig.api.baseUrl;
    firstValueFrom(this.httpClient.get<any>(`${publicPath}/version`))
      .then(response =>
        this.appVersion = response.version);
  }

}

